import PhoneSVG from "@design-system/ui-icons/vanilla/Phone"
import { createIcon } from "../createIcon"

export const PhoneIcon = createIcon(PhoneSVG)
